/**
 * Primary drill-down links pinned to the top-right of a feed row (under the
 * expand chevron) so they stay visible when the card is collapsed.
 */
import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";

export interface FeedRowCornerLink {
  href: string;
  label: string;
}

export function FeedRowCornerActions({
  links,
  onMarkDone,
}: {
  links: FeedRowCornerLink[];
  /** Per-booking opportunity rows: personal dismiss below the drill-down link. */
  onMarkDone?: () => void;
}) {
  if (links.length === 0 && !onMarkDone) return null;
  return (
    <div className="flex max-w-[9.5rem] flex-col items-end gap-1 sm:max-w-none">
      {links.map((link) => (
        <Link
          key={`${link.href}:${link.label}`}
          to={link.href}
          onClick={(e) => e.stopPropagation()}
          className="inline-flex max-w-full items-center justify-end gap-0.5 truncate rounded-full bg-primary/10 px-2 py-0.5 text-[10px] font-medium leading-tight text-primary transition-colors hover:bg-primary/20"
        >
          <span className="truncate">{link.label}</span>
          <ArrowUpRight className="size-2.5 shrink-0" />
        </Link>
      ))}
      {onMarkDone && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onMarkDone();
          }}
          className="inline-flex max-w-full items-center justify-end gap-0.5 truncate rounded-full bg-emerald-500/10 px-2 py-0.5 text-[10px] font-medium leading-tight text-emerald-600 transition-colors hover:bg-emerald-500/20 dark:text-emerald-400"
        >
          <Check className="size-2.5 shrink-0" aria-hidden />
          <span className="truncate">Mark as done</span>
        </button>
      )}
    </div>
  );
}
